import React, { useMemo } from "react";
import routesConfig from "@/config/routes.config";
import RxSubNav from "./RxSubNav";

const RxEventsSubNav: React.FC = (props): JSX.Element => {
  const subroutes = useMemo(() => {
    const routes =
      routesConfig.find(({ name }) => name === "events")?.routes || [];
    return ["events", "on-demand", "my-events"].map((name) =>
      routes.find((route) => route.name === name)
    );
  }, []);

  return <RxSubNav items={subroutes} {...props} />;
};

export default RxEventsSubNav;
